/*
 * @Description:
 * @Date: 2020-07-18 16:13:15
 */

import { BI } from '@/api/ajax';
import combination from './combination';
import { percentage } from '@/tools/index';
import {
  createBarSeries,
  createBarCircleSeries,
  createLineSeries,
  createMapSeries
} from '../components/Echarts/echartOption';
import { axisFormatter, dealProvince, dealTips } from '../tools/index';

export default {
  query: {},
  // 上部分
  ...combination,
  // 拜访医院分布 TODO:数据有问题
  queryHospitalCategoryInfo() {
    return new Promise(async (resolve, reject) => {
      let {
        data: { data: resp }
      } = await BI[this.query.serviceType].queryHospitalCategoryInfo(
        this.query
      );
      let { finalData, finalDataCount } = resp || {
        finalData: [],
        finalDataCount: 0
      };
      let header = [
        { label: '地名', prop: 'd' },
        { label: '医院数量（所）', prop: 'v' },
        { label: '百分比(%)', prop: 'b' }
      ];
      const { data, series0data } = dealProvince(finalData, finalDataCount);
      resolve({
        key: 'queryHospitalCategoryInfo',
        value: {
          header: {
            index: 1,
            title: '拜访医院分布',
            name: '拜访医院分布'
          },
          table: { header, data, finalDataCount, isNormal: true },
          useMapLayout: true,
          echart: [
            {
              echartType: 'map',
              echartStyle: { width: '630px', height: '450px' },
              echartOption: {
                series: createMapSeries(series0data, finalDataCount)
              }
            }
          ]
        }
      });
    });
  },
  // 照片
  // querytaskImgs() {
  //   return new Promise(async (resolve, reject) => {
  //     let { data } = await BI[this.query.serviceType].querytaskImgs(this.query);
  //     let resp = data.data || [];

  //     let images = resp.map(item => item.imgUrl);
  //     resolve({
  //       key: 'querytaskImgs',
  //       value: {
  //         header: {
  //           index: 2,
  //           title: '拜访医院照片墙',
  //           name: '拜访医院照片墙'
  //         },
  //         images
  //       }
  //     });
  //   });
  // },
  // 拜访时间
  queryVisitTimeInfo() {
    return new Promise(async (resolve, reject) => {
      let {
        data: { data: resp }
      } = await BI[this.query.serviceType].queryVisitTimeInfo(this.query);
      let { finalData, finalDataCount } = resp || {
        finalData: [],
        finalDataCount: 0
      };
      let header = [
        { label: '时间段', prop: 'd' },
        { label: '机构数量（所）', prop: 'v' },
        { label: '百分比(%)', prop: 'b' }
      ];
      let data = [];
      let xAxisData = [];
      let series0data = [];
      finalData.forEach(item => {
        let [m] = Object.entries(item);
        xAxisData.push(m[0]);
        series0data.push(m[1]);
        const [x1, x2] = (m[0] || '').split('-');
        data.push({
          d: `${x1}-<br>${x2}`,
          v: m[1],
          b: percentage(m[1], finalDataCount)
        });
      });
      resolve({
        key: 'queryVisitTimeInfo',
        value: {
          header: {
            index: 3,
            title: '拜访时间',
            name: '拜访时间'
          },
          table: { header, data, finalDataCount },
          echart: [
            {
              echartType: 'bar2',
              echartOption: {
                tooltip: {
                  formatter: function(params) {
                    const { axisValue, value } = params[0] || params || {};
                    return dealTips(axisValue, value, '所');
                  }
                },
                xAxis: {
                  type: 'category',
                  data: xAxisData,
                  axisLabel: {
                    interval: 0,
                    textStyle: {
                      color: '#666',
                      fontSize: 12
                    }
                  }
                },
                yAxis: {
                  name: '机构数量（所）'
                },
                series: createBarSeries(series0data, true)
              }
            }
          ]
        }
      });
    });
  },
  // 拜访时长
  queryVisitMinuteInfo() {
    return new Promise(async (resolve, reject) => {
      let {
        data: { data: resp }
      } = await BI[this.query.serviceType].queryVisitMinuteInfo(this.query);
      let { finalData, finalDataCount } = resp || {
        finalData: [],
        finalDataCount: 0
      };
      let header = [
        { label: '分钟数', prop: 'd' },
        { label: '机构数量（所）', prop: 'v' },
        { label: '百分比(%)', prop: 'b' }
      ];
      let data = [];
      let xAxisData = [];
      let series0data = [];
      let formatData = {};
      finalData.forEach(item => {
        let min = Math.min(20, item);
        formatData[min] = formatData[min] ? formatData[min] + 1 : 1;
      });
      Object.entries(formatData).forEach(item => {
        let l = +item[0] === 20 ? '20min+' : item[0] + 'min';
        xAxisData.push(l);
        series0data.push(item[1]);
        data.push({
          d: l,
          v: item[1],
          b: percentage(item[1], finalDataCount)
        });
      });
      resolve({
        key: 'queryVisitMinuteInfo',
        value: {
          header: {
            index: 4,
            title: '拜访时长',
            name: '拜访时长'
          },
          table: { header, data, finalDataCount },
          echart: [
            {
              echartType: 'line',
              echartOption: {
                tooltip: {
                  formatter: function(params) {
                    const { axisValue, value } = params[0] || params || {};
                    return dealTips(axisValue, value, '所');
                  }
                },
                xAxis: {
                  type: 'category',
                  data: xAxisData
                },
                yAxis: {
                  name: '机构数量（所）'
                },
                series: createLineSeries(series0data)
              }
            }
          ]
        }
      });
    });
  },
  // 客户反馈
  queryCustomerFeedBack() {
    return new Promise(async (resolve, reject) => {
      let {
        data: { data: resp }
      } = await BI[this.query.serviceType].queryCustomerFeedBack(this.query);
      let { finalData, finalDataCount } = resp || {
        finalData: {},
        finalDataCount: 0
      };
      let header = [
        { label: '选项', prop: 'd' },
        { label: '数量（份）', prop: 'v' },
        { label: '百分比(%)', prop: 'b' }
      ];
      let data = [];
      let xAxisData = [];
      let series0data = [];
      Object.entries(finalData).forEach(item => {
        series0data.push({
          value: item[1],
          name: item[0] + `:${item[1]}份`
        });
        data.push({
          d: item[0],
          v: item[1],
          b: percentage(item[1], finalDataCount)
        });
      });
      const testArr = [
        { name: '10', value: 10, d: '10%' },
        { name: '20', value: 20, d: '20%' },
        { name: '30', value: 30, d: '20%' },
        { name: '40', value: 40, d: '20%' },
        { name: '50', value: 50, d: '20%' },
        { name: '100', value: 100, d: '20%' }
      ];
      resolve({
        key: 'queryCustomerFeedBack',
        value: {
          header: {
            index: 5,
            title: '客户反馈',
            name: '客户反馈'
          },
          customComponents: [
            {
              options: {
                table: {
                  header: header,
                  data: data,
                  finalDataCount,
                  isNormal: true
                },
                series0data: series0data,
                finalDataCount: finalDataCount
              },
              com: require('../components/customCharts/pie3dType2').default
            }
          ]
        }
      });
    });
  },

  async run(query) {
    this.query = query;
    let arr = [];
    for (let i in this) {
      if (
        this.hasOwnProperty(i) &&
        i !== 'run' &&
        typeof this[i] === 'function'
      ) {
        arr.push(this[i]());
      }
    }
    return new Promise((resolve, reject) => {
      Promise.all(arr)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};
